import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Button } from '@ontruck/orc';

import DriverListContainer from 'components/DriverList';

import style from './style.module.scss';
import useCarriersLite from 'utils/hooks/useCarriersLite';

const Drivers = ({
  intl,
  drivers,
  onNewDriver,
  onEditDriver,
  onActiveClick,
  onFilterDriver,
  allowNew = true,
  carrier,
}) => {
  const t = intl.messages.components.CarrierDetails;
  const { isDriverChatDisabled, isEditDriverDisabled } = useCarriersLite();
  return (
    <div className={style.section}>
      <div className={style.sectionHeader}>
        <h2 className={style.sectionTitle}>{t.drivers_title}</h2>
        {!isEditDriverDisabled && (
          <Button
            ghost
            skin="primary"
            icon="plus"
            iconPosition="left"
            size="M"
            className={style.addDriverButton}
            onClick={onNewDriver}
            disabled={!allowNew}
          >
            {t.drivers_add}
          </Button>
        )}
      </div>

      {drivers && drivers.length ? (
        <DriverListContainer
          isDriverChatDisabled={isDriverChatDisabled}
          drivers={drivers}
          carrier={carrier}
          onCellClick={(id) => onEditDriver(id)}
          onActiveClick={onActiveClick}
          onFilterDriver={onFilterDriver}
        />
      ) : null}
    </div>
  );
};

Drivers.propTypes = {
  carrier: PropTypes.object,
  intl: PropTypes.any,
  drivers: PropTypes.array,
  onNewDriver: PropTypes.func,
  onEditDriver: PropTypes.func,
  onActiveClick: PropTypes.func,
  onFilterDriver: PropTypes.func,
  allowNew: PropTypes.bool,
};

export default injectIntl(Drivers);
